import { useState, useEffect } from "react";
import axios from "axios";
import { Reveal } from "@/components/site/Reveal";
import { Film } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VideoPills = () => {
  const [pills, setPills] = useState([]);

  useEffect(() => {
    axios.get(`${API}/video-pills`).then(({ data }) => setPills(data)).catch(() => setPills([]));
  }, []);

  if (!pills.length) return null;

  return (
    <section id="video-pillole" className="py-20 md:py-28 px-6 md:px-12 bg-[#15201A]" data-testid="video-pills-section">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#C98E6E] flex items-center gap-2">
            <Film size={18} /> Video pillole
          </p>
          <h2 className="mt-4 font-serif-display font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white max-w-3xl">
            Pillole video sugli <em className="italic text-[#7D9285]">impianti a carico immediato</em>
          </h2>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-white/60 max-w-2xl">
            Risposte brevi e chiare alle domande più comuni, direttamente dal nostro studio.
          </p>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-3xl mx-auto sm:max-w-none" data-testid="video-pills-grid">
          {pills.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.06}>
              <figure data-testid={`video-pill-${p.id}`}>
                <div className="relative aspect-[9/16] rounded-[24px] overflow-hidden border border-white/15 bg-black max-w-xs mx-auto">
                  <video
                    src={p.video_url}
                    poster={p.poster || undefined}
                    controls
                    preload={p.poster ? "none" : "metadata"}
                    playsInline
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </div>
                <figcaption className="mt-4 text-center text-white/80 font-semibold text-base">{p.title}</figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
